import React, { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from 'recharts';
import { getProductPrice } from '../../utils/pricing';

export default function RevenueExpenseChart() {
    const { products, sales, expenses } = useAppContext();

    const data = useMemo(() => {
        const map = new Map();

        sales.forEach((s) => {
            const d = new Date(s.date);
            const key = d.toLocaleDateString('pt-BR');
            const product = products.find((p) => p.id === s.productId);
            if (!product) return;
            const price = getProductPrice(product);
            const revenue = price * s.quantity;

            const item = map.get(key) || { date: key, revenue: 0, expenses: 0 };
            item.revenue += revenue;
            map.set(key, item);
        });

        expenses.forEach((e) => {
            const d = new Date(e.date);
            const key = d.toLocaleDateString('pt-BR');
            const item = map.get(key) || { date: key, revenue: 0, expenses: 0 };
            item.expenses += e.amount;
            map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => {
            const [da, ma, ya] = a.date.split('/');
            const [db, mb, yb] = b.date.split('/');
            return new Date(`${ya}-${ma}-${da}`) - new Date(`${yb}-${mb}-${db}`);
        });
    }, [products, sales, expenses]);

    if (!data.length) {
        return (
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <h2 className="h6 mb-2">Fluxo diário de receita e despesas</h2>
                    <p className="text-muted small mb-0">
                        Lance vendas e despesas para visualizar o gráfico.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="card shadow-sm mb-4">
            <div className="card-body">
                <h2 className="h6 mb-3">Fluxo diário de receita e despesas</h2>
                <div style={{ width: '100%', height: 260 }}>
                    <ResponsiveContainer>
                        <LineChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="revenue"
                                stroke="#0d6efd"
                                name="Receita"
                                strokeWidth={2}
                            />
                            <Line
                                type="monotone"
                                dataKey="expenses"
                                stroke="#dc3545"
                                name="Despesas"
                                strokeWidth={2}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
